import React from 'react';
import {useParams} from "react-router-dom";
import {findLocation} from '../Calendar/CalendarUtil';
import {EmailOrPhoneLocation, MutateLocationRequest, space} from "../../../../provider_api";
import {EditableStringField} from "../../../../components/Editable/EditableStringField";
import {EditableAddressField} from "../../../../components/Editable/EditableAddressField";
import {EditableTimeZoneField} from "../../../../components/Editable/EditableTimeZoneField";
import {EditablePhotoUpload} from "../../../../components/Editable/EditablePhotoUpload";
import {KensuProfileEditor} from "../../../../components/table/KensuProfileEditor";
import {EditableYesNo} from "../../../../components/Editable/EditableYesNo";
import {EditableVerifiedEmailField} from "../../../../components/Editable/EditableVerifiedEmailField";
import {EditableVerifiedPhoneInputField} from "../../../../components/Editable/EditableVerifiedPhoneInputField";
import IBusinessLocationProto = space.kenko.proto.IBusinessLocationProto;
import BusinessLocationProto = space.kenko.proto.BusinessLocationProto;

export const AddOrEditLocation = () => {

  // If editing, the sku is a param. 
  const {idParam} = useParams();

  return <KensuProfileEditor<IBusinessLocationProto>
      idParam={idParam}
      entityName={'Location'}
      entityListViewLink={'../locations'}
      archiveField={"archived"}
      getFromProfile={(profile, id) => findLocation(profile, id)}
      getTitle={location => location.locationName}
      newBlankType={() => new BusinessLocationProto()}
      getRpcMethod={isUpdate => isUpdate ? 'update_location' : 'create_location'}
      getRpcPayload={location => {
        console.log('payload payload', JSON.stringify(location));
        return MutateLocationRequest.encode(new MutateLocationRequest({
          location: location
        })).finish()}}
  >

    <EditableStringField<IBusinessLocationProto>
        inputType={'text'}
        label={'Name'}
        field={'locationName'}
    />

    <EditableAddressField<IBusinessLocationProto>
        label={'Address'}
        immutable={true}
        errorKey={'address'}
        getter={entity => entity.physicalLocation?.address}
        setter={(entity, v) => ({
          ...entity,
          physicalLocation: {
            ...entity.physicalLocation,
            address: v?.formatted_address,
            lat: v?.geometry?.location?.lat(),
            lng: v?.geometry?.location?.lng(),
          }
        })}
    />

    <EditableTimeZoneField<IBusinessLocationProto>
        label={'Time zone'}
        getter={entity => entity.physicalLocation?.timeZone}
        setter={(entity, value) => ({
          ...entity,
          physicalLocation: {
            ...entity.physicalLocation,
            timeZone: value
          }
        })}
        errorKey={'timeZone'}
        immutable={true}/>

    <EditableYesNo<IBusinessLocationProto>
        label={'Private'}
        getter={entity => entity.physicalLocation?.private}
        setter={(entity, value) => ({
          ...entity,
          physicalLocation: {
            ...entity.physicalLocation,
            private: value
          }
        })}    
        helpText={'The exact location will be hidden until a client books.'}
    
    />
    
    <EditableVerifiedEmailField<IBusinessLocationProto>
        label={'Email Address (Optional)'}
        errorKey={'email'}
        location={EmailOrPhoneLocation.BUSINESS}
        getter={entity => entity.physicalLocation?.email}
        setter={(entity, value) => ({
          ...entity,
          physicalLocation: {
            ...entity.physicalLocation,
            email: value
          }
        })}
    />

    <EditableVerifiedPhoneInputField<IBusinessLocationProto>
        label={'Phone number (Optional)'}
        location={EmailOrPhoneLocation.BUSINESS}
        getter={entity => entity.physicalLocation?.phone}
        setter={(entity, value) => ({
          ...entity,
          physicalLocation: {
            ...entity.physicalLocation,
            phone: value
          }
        })}
        errorKey={'phone'}
    />

    <EditablePhotoUpload<IBusinessLocationProto>
        label={'Location Photo'}
        errorKey={"imageUrl"}
        getter={entity => entity.physicalLocation?.imageUrl}
        setter={(entity, value) => ({
          ...entity,
          physicalLocation: {
            ...entity.physicalLocation,
            imageUrl: value
          }
        })}
    />
  </KensuProfileEditor>;
};

